module.exports = " <div class=list thin-border> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list.vue
// module id = 236
// module chunks = 0